<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import Foot from "./components/Foot.vue";
import storage from "@/service/storage-service";
import wx from "weixin-js-sdk";
export default {
  name: "App",
  components: {
    Foot,
  },
  data() {
    return {
      parentUserId: "",
    };
  },
  created() {
    this.getCode().then((res) => {
      // this.login();
      // wx.ready(function () {
      //   console.log("wx", wx);
      //   wx.checkJsApi({
      //     jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline", 'showOptionMenu'],
      //     success: function (res) { },
      //   });

      // });
    });
  },
  mounted() {},
  methods: {
    getCode() {
      return new Promise((resolve) => {
        this.http.resource
          .post("/api/wx-config", {
            url: location.href.split("#")[0],
          })
          .then((res) => {
            wx.config({
              debug: false, // 默认为false  为true的时候是调试模式，会打印出日志
              appId: res.appid,
              timestamp: res.timestamp,
              nonceStr: res.nonceStr,
              signature: res.signature,
              jsApiList: [
                "onMenuShareAppMessage",
                "onMenuShareTimeline",
                "showOptionMenu",
                "updateAppMessageShareData",
                "updateTimelineShareData",
              ],
            });
            resolve();
          });
      });
    },
    // 授权等录
    login() {
      //   Toast.fail(222);
      console.log(this.$route.query.parentUserId)
      if (this.$route.query.parentUserId) {
        this.parentUserId = this.$route.query.parentUserId;
      }
      console.log(this.parentUserId);
      // let type = this.wx.isWxAgent();
      // if (type) {
      //   this.show = 1;
      // } else {
      //   this.show = 0;
      // }
      // console.log(type, "type");
      let userId = this.storage.get("userId");
      if (userId) {
        if (this.wx.isWxAgent()) {
          // let code = this.getQueryString("code") || this.$route.query.code;
          let code = this.getQueryString("code");
          console.log("code", code);
          if (!code) {
            console.log("code", code);
            console.log(location.href)
            let wxAuthUrl = this.wx.getAuthUrl(
              location.href,
              "snsapi_userinfo",
              "jdf"
            );
            location.href = wxAuthUrl;
            console.log(wxAuthUrl, 111);
          } else {
            let state = this.getQueryString("state") || this.$route.query.state;
            if (state == "jdf") {
              let params = {
                code: code,
              };
              if (this.parentUserId) {
                params.parentUserId = this.parentUserId;
              }
              Toast.loading({
                message: "登陆中...",
                forbidClick: true,
                duration: 0,
              });
              // this.storage.remove("userId");
              // this.storage.remove("user");
              this.http.resource
                .post("/api/user-auth-by-code1", params)
                .then((res) => {
                  if (!res.errCode) {
                    if (res.data) {
                      Toast.clear();
                      console.log(res.data);
                      if (res.data.userId) {
                        this.storage.set("userId", res.data.userId);
                      }
                      this.storage.set("user", res.data);
                      this.user = res.data;
                    }
                  }
                });
            }
          }
        }
      }
    },
    getQueryString: function (name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
  },
};
</script>
<style>
::-webkit-scrollbar {
  display: none;
}

#app {
  height: 100%;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/App.vue